import React from 'react'
import { useFilters } from '../../Common/Hooks/useFilters'

export interface OutcomeTypeLinkProps {
	outcomeType: string
}

export function OutcomeTypeLink(props: OutcomeTypeLinkProps): JSX.Element {

	const { addFilter } = useFilters()

	return (
		// eslint-disable-next-line jsx-a11y/anchor-is-valid
		<a className='filter' href='#' onClick={(e) => {
			e.preventDefault()
			addFilter('outcomeTypes', `${props.outcomeType}`)
		}}>
			{props.outcomeType}
		</a>
	)
}
